import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import { selectAccountTransactionsListItems } from "../../../../../../redux/account-transactions/selector";
import { accountTransactions } from "../../../../../../redux/account-transactions/action";
import { selectListItems } from "../../../../../../redux/library/selector";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const ManagementAccountsTranscations = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const libraryData = useSelector(selectListItems)
    const accountTranscationItems = useSelector(selectAccountTransactionsListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'FinancialYearId', headerName: 'Financial Year' },
            { field: 'LedgerName', headerName: 'Ledger Name', searchField: 'LedgerName', sortable: true, filter: true, filterType: 'text' },
            {
                field: 'OwnerTypeId',
                headerName: 'Owner Type',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.AccountTransactionOwnerType }
            },
            {
                field: 'ReferenceTypeId',
                headerName: 'Reference Type',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.AccountReferenceType }
            },
            { field: 'ReferenceDate', headerName: 'Reference Date', isDateValueFormat: true },
            { field: 'CreditAmount', headerName: 'Credit Amount', isCurrencyValueFormat: true },
            { field: 'DebitAmount', headerName: 'Debit Amount', isCurrencyValueFormat: true },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    }

    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            // name: 'Reload',
            callback: () => handleReloadData(),
        },
    ];

    const fetchAccountsTranscationsList = () => {
        dispatch(accountTransactions.list({
            url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/account-transactions/fetch`,
            entity: 'accountTransactions',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
            }
        }))
    }

    useEffect(() => {
        createColumnDefs()
        fetchAccountsTranscationsList()
    }, [pageData, pageSize])

    const handleReloadData = () => {
        fetchAccountsTranscationsList();
    }

    const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        dispatch(accountTransactions.list({
            url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/account-transactions/fetch`,
            entity: 'accountTransactions',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
            }
        }));
    }

    return (
        <>
            {accountTranscationItems?.isLoading ? <PageLoader /> :
                <Table 
                checkboxConfig={{
                    allowMultiSelect: true,
                    defaultSelectedIds: [],
                    isDisabled: false,
                    keyColumn: 'Id',
                  }}
                columnData={columnDefs} rowData={accountTranscationItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
                    enableFilter={true} onSearch={handleSearch}
                    paginationData={accountTranscationItems?.result?.pagination} additionButtons={additionButtons}
                    headingName="Ledger Transcations"
                />
            }
        </>
    );
};

export default ManagementAccountsTranscations;
